import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { ILive } from '@/Module/Live/Model/DataModel';
import { LiveService } from '@/Module/Live/Service';
import type { IState } from '@/Module/Store/Model';

export const getListLiveAction = createAsyncThunk<IGatewayResponse<ILive[]>>(
  'live/getList',
  async (_, { signal, getState }) => {
    return LiveService.getList(
      {
        pageNo: (getState() as IState).live.page,
        pageCount: (getState() as IState).live.rows,
      },
      signal,
    ).then(({ data }) => data);
  },
);
